import { render, staticRenderFns } from "./PaywallModal.vue?vue&type=template&id=88e21c26&scoped=true"
import script from "./PaywallModal.vue?vue&type=script&lang=js"
export * from "./PaywallModal.vue?vue&type=script&lang=js"
import style0 from "./PaywallModal.vue?vue&type=style&index=0&id=88e21c26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e21c26",
  null
  
)

export default component.exports